function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ../~/_@babel_runtime@7.6.2@@babel/runtime/helpers/interopRequireDefault.js
// module id = 188
// module chunks = 0